import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, resolveDirective as _resolveDirective, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9e9b6664"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-h6" }, "ダウンロード", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "q-py-sm text-h4" }, "必ずお読みください", -1))
const _hoisted_3 = {
  class: "text-center",
  style: {"width":"100%"}
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-caption" }, "ダウンロードが始まるまでにやや時間がかかります", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-h4" }, "ご利用端末はモバイルです", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", null, "お使いの端末はモバイルのため、配布ワールドを遊ぶことができない可能性があります。"),
  /*#__PURE__*/_createElementVNode("p", null, "これを理解したうえでダウンロードを行いますか？")
], -1))

import TermsOfUse from '@/views/Works/Agreements/TermsOfUse.vue';
import Platform from 'quasar/src/plugins/Platform.js';;
import { ref } from 'vue';

interface Prop {
  productName: string
  downloadLink?: string
}

export default /*#__PURE__*/_defineComponent({
  __name: 'downloadBtn',
  props: {
    productName: null,
    downloadLink: null
  },
  setup(__props: any) {

const prop = __props as {
  productName: string
  downloadLink?: string
};



const showAgreement = ref(false)
const showCheckDownload = ref(false)

function AgreeBtn() {
  if (Platform.is.mobile) {
    showCheckDownload.value = true
  }
  else {
    open(prop.downloadLink)
  }
}

return (_ctx: any,_cache: any) => {
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_page_sticky = _resolveComponent("q-page-sticky")!
  const _component_q_space = _resolveComponent("q-space")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_scroll_area = _resolveComponent("q-scroll-area")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_q_page_sticky, {
      position: "bottom-right",
      offset: [25, 25]
    }, {
      default: _withCtx(() => [
        _withDirectives(_createVNode(_component_q_btn, {
          round: "",
          icon: "file_download",
          color: "primary",
          size: "2rem",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (showAgreement.value = true))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_tooltip, null, {
              default: _withCtx(() => [
                _hoisted_1
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 512), [
          [_vShow, __props.downloadLink !== void 0]
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_q_dialog, {
      modelValue: showAgreement.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((showAgreement).value = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_q_card_section, { class: "row items-center q-pb-none" }, {
              default: _withCtx(() => [
                _hoisted_2,
                _createVNode(_component_q_space),
                _withDirectives(_createVNode(_component_q_btn, {
                  icon: "close",
                  flat: "",
                  round: "",
                  dense: ""
                }, null, 512), [
                  [_directive_close_popup]
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_q_separator, { inset: "" }),
            _createVNode(_component_q_card_section, null, {
              default: _withCtx(() => [
                _createVNode(_component_q_scroll_area, { class: "scroll-area" }, {
                  default: _withCtx(() => [
                    _createVNode(TermsOfUse, { "product-name": __props.productName }, null, 8, ["product-name"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_q_separator, { inset: "" }),
            _createVNode(_component_q_card_actions, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _hoisted_4,
                  _withDirectives(_createVNode(_component_q_btn, {
                    label: "利用規約に同意してダウンロード",
                    color: "primary",
                    onClick: AgreeBtn,
                    class: "text-h6"
                  }, null, 512), [
                    [_directive_close_popup]
                  ])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_q_dialog, {
      modelValue: showCheckDownload.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((showCheckDownload).value = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_q_card_section, { class: "row items-center q-pb-none" }, {
              default: _withCtx(() => [
                _hoisted_5,
                _createVNode(_component_q_space),
                _withDirectives(_createVNode(_component_q_btn, {
                  icon: "close",
                  flat: "",
                  round: "",
                  dense: ""
                }, null, 512), [
                  [_directive_close_popup]
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_q_card_section, null, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            }),
            _createVNode(_component_q_card_actions, { align: "right" }, {
              default: _withCtx(() => [
                _withDirectives(_createVNode(_component_q_btn, {
                  label: "キャンセル",
                  color: "grey-5",
                  class: "text-black"
                }, null, 512), [
                  [_directive_close_popup]
                ]),
                _withDirectives(_createVNode(_component_q_btn, {
                  label: "OK!",
                  color: "primary",
                  href: __props.downloadLink
                }, null, 8, ["href"]), [
                  [_directive_close_popup]
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})